import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { CircleCheckIcon, CircleIcon } from "@lucide/icons";

import { styled } from "simplydo/react/styled";
import { useTheme } from "simplydo/react/theme";
import { Divider } from "simplydo/react/ui/divider";
import { H3 } from "simplydo/react/ui/header";
import { Icon } from "simplydo/react/ui/icon";
import { List, ListContent, ListItem } from "simplydo/react/ui/list";

import { useAppSelector } from "store";

const TaskList = styled.div`
  width: 100%;
  padding: 15px;
  border-radius: 5px !important;
  margin-bottom: 20px;
  background-color: #fff;
  box-shadow: 0.5px 0.5px 2.5px 1px #c0c0c0;
  h3 {
    color: black;
  }
`;

const HomeTasklist = () => {
  const user = useAppSelector((state) => state.user);
  const theme = useTheme();
  const { t } = useTranslation();
  const org = user?.ownerOrganisation;

  if (!user) return null;

  const tasklistComplete =
    user.engagements.includes("viewedChallenge") &&
    ((user.ideaCount && user.ideaCount > 0) ||
      user.engagements.includes("createdIdea")) &&
    user.profile.avatar &&
    (org?.superadminTags?.innovationType !== "externalInnovation" ||
      (user.profile.linkedin?.length ?? 0) > 0);
  if (tasklistComplete) return null;

  return (
    <TaskList theme={theme}>
      <H3>{t("home.tasklist.title", { user })}</H3>
      <p>{t("home.getStarted.info")}</p>
      <Divider />
      <List>
        <ListItem>
          <Icon
            size="large"
            icon={
              user.profile.avatar &&
              (user.profile.tagline || user.profile.overview)
                ? CircleCheckIcon
                : CircleIcon
            }
            color={
              user.profile.avatar &&
              (user.profile.tagline || user.profile.overview)
                ? "green"
                : undefined
            }
          />
          <ListContent style={{ fontSize: 18 }}>
            <Link
              to="/preferences/profile"
              style={{ color: "#000", textDecoration: "underline" }}
            >
              {t("home.tasklist.createProfile")}
            </Link>
          </ListContent>
        </ListItem>
        <ListItem>
          <Icon
            size="large"
            icon={
              user.engagements.includes("viewedChallenge")
                ? CircleCheckIcon
                : CircleIcon
            }
            color={
              user.engagements.includes("viewedChallenge") ? "green" : undefined
            }
          />
          <ListContent style={{ fontSize: 18 }}>
            <Link
              to="/challenges/discover"
              style={{ color: "#000", textDecoration: "underline" }}
            >
              {t("home.tasklist.viewChall")}
            </Link>
          </ListContent>
        </ListItem>
        <ListItem>
          <Icon
            size="large"
            icon={
              (user.ideaCount && user.ideaCount > 0) ||
              user.engagements.includes("createdIdea")
                ? CircleCheckIcon
                : CircleIcon
            }
            color={
              (user.ideaCount && user.ideaCount > 0) ||
              user.engagements.includes("createdIdea")
                ? "green"
                : undefined
            }
          />
          <ListContent style={{ fontSize: 18 }}>
            <Link
              to="/challenges/discover"
              style={{ color: "#000", textDecoration: "underline" }}
            >
              {t("home.tasklist.createIdea")}
            </Link>
          </ListContent>
        </ListItem>
        {org?.superadminTags?.innovationType === "externalInnovation" && (
          <ListItem>
            <Icon
              size="large"
              icon={
                user.profile.linkedin && user.profile.linkedin.length > 0
                  ? CircleCheckIcon
                  : CircleIcon
              }
              color={
                user.profile.linkedin && user.profile.linkedin.length > 0
                  ? "green"
                  : undefined
              }
            />
            <ListContent style={{ fontSize: 18 }}>
              <Link
                to="/preferences/profile"
                style={{ color: "#000", textDecoration: "underline" }}
              >
                {"Add your LinkedIn"}
              </Link>
            </ListContent>
          </ListItem>
        )}
      </List>
    </TaskList>
  );
};

export default HomeTasklist;
